import React, { useEffect, useState } from "react";
import Axios from "../../axios/axios";
import { useLocation } from "react-router-dom";

export default function RentOutReport() {
  const location = useLocation();
  const today = new Date().toISOString().split("T")[0];

  const [rentedFromDate, setRentedFromDate] = useState(today);
  const [rentedToDate, setRentedToDate] = useState(today);
  const [scheduledFromDate, setScheduledFromDate] = useState(today);
  const [scheduledToDate, setScheduledToDate] = useState(today);
  const [rentedData, setRentedData] = useState([]);
  const [rentedCount, setRentedCount] = useState(0);

  const [scheduledData, setScheduledData] = useState([]);
  const [scheduledCount, setScheduledCount] = useState(0);
  const [rentedAmount, setRentedAmount] = useState(0);
  const [scheduledAmount, setScheduledAmount] = useState(0);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  const query = new URLSearchParams(location.search);
  const defaultType =
    query.get("type") === "scheduled" ? "scheduled" : "rented";
  const isDashboardNavigation = query.get("type") === "scheduled";

  const [rentType, setRentType] = useState(defaultType);

  const tableData = rentType === "rented" ? rentedData : scheduledData;
  const totalCount = rentType === "rented" ? rentedCount : scheduledCount;

  const getRentedReport = async () => {
    try {
      const res = await Axios.get(
        `/api/order/rentOutReport?from=${rentedFromDate}&to=${rentedToDate}&user=${selectedUser}`,
      );
      console.log("Report", res.data);
      const data = res.data.data || [];

      setRentedData(data);
      setRentedCount(res.data.count || 0);

      const total = data.reduce((sum, item) => sum + (item.amount || 0), 0);
      setRentedAmount(total);
      if (!selectedUser) {
        setUsers(res.data.customers || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getScheduledReport = async () => {
    try {
      let url = "";

      if (rentType === "scheduled") {
        url = `/api/order/toBeRentOutReport?from=${today}&to=${today}&user=${selectedUser}`;
      } else {
        url = `/api/order/toBeRentOutReport?from=${scheduledFromDate}&to=${scheduledToDate}&user=${selectedUser}`;
      }

      const res = await Axios.get(url);

      const data = res.data.data || [];

      setScheduledData(data);
      setScheduledCount(res.data.count || 0);

      const total = data.reduce((sum, item) => sum + (item.amount || 0), 0);
      setScheduledAmount(total);
      if (!selectedUser) {
        setUsers(res.data.customers || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (rentType === "rented") {
      getRentedReport();
    } else {
      getScheduledReport();
    }
  }, [
    rentedFromDate,
    rentedToDate,
    scheduledFromDate,
    scheduledToDate,
    selectedUser,
    rentType,
  ]);

  const totalAmount = rentType === "rented" ? rentedAmount : scheduledAmount;

  const changeDate = (days) => {
    if (rentType === "rented") {
      const current = new Date(rentedFromDate);
      current.setDate(current.getDate() + days);

      const newDate = current.toISOString().split("T")[0];

      setRentedFromDate(newDate);
      setRentedToDate(newDate);
    } else {
      const current = new Date(scheduledFromDate);
      current.setDate(current.getDate() + days);

      const newDate = current.toISOString().split("T")[0];

      setScheduledFromDate(newDate);
      setScheduledToDate(newDate);
    }
  };
  const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};

  return (
    <div>
      <div className="mb-3">
        <button
          className={`btn mr-2 mb-2 ${
            rentType === "rented" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => {
            setRentType("rented");
            setSelectedUser("");
          }}
        >
          Rented Out
        </button>

        <button
          className={`btn mb-2 ${
            rentType === "scheduled" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => {
            setRentType("scheduled");
            setSelectedUser("");
          }}
        >
          To Be Rented Out Today
        </button>

        <button
          className={`btn mb-2 ml-2 ${
            rentType === "scheduledCustom"
              ? "btn-primary"
              : "btn-outline-primary"
          }`}
          onClick={() => {
            setRentType("scheduledCustom");
            setSelectedUser("");
          }}
        >
          To Be Rented Out (Custom)
        </button>
      </div>
      {/* Filters */}
      <div className="card mb-3">
        <div className="card-body d-flex align-items-end gap-3 flex-wrap">
          <div className="mr-3">
            <label>From</label>
            <input
              type="date"
              className="form-control"
              value={rentType === "rented" ? rentedFromDate : scheduledFromDate}
              disabled={rentType === "scheduled"}
              onChange={(e) =>
                rentType === "rented"
                  ? setRentedFromDate(e.target.value)
                  : setScheduledFromDate(e.target.value)
              }
            />
          </div>

          <div className="mr-3">
            <label>To</label>
            <input
              type="date"
              className="form-control"
              value={rentType === "rented" ? rentedToDate : scheduledToDate}
              disabled={rentType === "scheduled"}
              onChange={(e) =>
                rentType === "rented"
                  ? setRentedToDate(e.target.value)
                  : setScheduledToDate(e.target.value)
              }
            />
          </div>
          {rentType === "rented" && (
            <button
              className="btn btn-outline-secondary"
              onClick={() => changeDate(-1)}
            >
              ⬅️ Prev
            </button>
          )}

          <button
            className="btn btn-outline-primary"
            onClick={() => {
              if (rentType === "rented") {
                setRentedFromDate(today);
                setRentedToDate(today);
              } else {
                setScheduledFromDate(today);
                setScheduledToDate(today);
              }
            }}
            disabled={
              rentType === "rented"
                ? rentedFromDate === today
                : scheduledFromDate === today
            }
          >
            📅 Today
          </button>

          {/* Next button (ONLY for custom scheduled) */}
          {rentType === "scheduledCustom" && (
            <button
              className="btn btn-outline-secondary"
              onClick={() => changeDate(1)}
            >
              Next ➡️
            </button>
          )}

          <button
            className="btn btn-primary"
            onClick={() => {
              if (rentType === "rented") {
                getRentedReport();
              } else {
                getScheduledReport();
              }
            }}
          >
            Filter
          </button>
        </div>
      </div>
      <div className="mr-3 mb-3">
        <label>Customer</label>
        <select
          className="form-control"
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
        >
          <option value="">All Customers</option>

          {users?.map((u) => (
            <option key={u._id} value={u._id}>
              {u.name}
            </option>
          ))}
        </select>
      </div>

      {/* Summary */}
      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card text-white bg-warning mb-2">
            <div className="card-body">
              <h6>Total Rent Out Items</h6>
              <h3>{totalCount}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card text-white bg-success">
            <div className="card-body">
              <h6>Total Amount</h6>
              <h3>₹ {totalAmount}</h3>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Rent Out Details</h4>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Product</th>
                  <th>Phone</th>
                  <th>Rent Date</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                {tableData.length > 0 ? (
                  tableData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>ADC_{item.orderId}</td>
                      <td>{item.customer}</td>
                      <td>{item.product}</td>
                      <td>{item.phone}</td>
                      <td>
                        {item.deliveredAt
                          ? formatDate(item.deliveredAt)
                          : "-"}
                      </td>

                      <td>
                        {item.startDate
                          ? formatDate(item.startDate)
                          : "-"}
                      </td>

                      <td>
                        {item.endDate
                          ? formatDate(item.endDate)
                          : "-"}
                      </td>

                      <td>₹ {item.amount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No rent out records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
